<div class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-40">
    <div class="bg-white rounded-md shadow-2xl w-full max-w-4xl animate-fade-in-down text-center flex flex-col max-h-[85vh]">
        <!-- HEADER SECTION - Dynamic colored border + icon based on type -->
        <div class="grid grid-cols-[6rem_auto] gap-4 border-b px-6 py-4 overflow-y-auto flex-1" [ngClass]="{
            '!border-t-green-100 !border-t-8 rounded-md successBorder': data.type === 'success',
            '!border-t-red-100 !border-t-8 rounded-md': data.type === 'error',
            '!border-t-blue-100 !border-t-8 rounded-md': dialogType() === 'info',
            '!border-t-amber-100 !border-t-8 rounded-md': data.type === 'warning'
        }">
            <!-- ICON CIRCLE - Colored based on dialog type -->
            <header [ngClass]="{
                'bg-green-100 text-green-600': data.type === 'success',
                'bg-red-100 text-red-600': data.type === 'error',
                'bg-blue-100 text-blue-600': dialogType() === 'info',
                'bg-amber-100 text-amber-600': data.type === 'warning'
            }" class="w-16 h-16 flex items-center justify-center rounded-full mx-auto mb-0">
                <!-- Success Checkmark -->
                @if (data.type === 'success') {
                <svg class="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 00-1.414 0L8 12.586 4.707 9.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l8-8a1 1 0 000-1.414z"
                        clip-rule="evenodd" />
                </svg>
                }
                <!-- Error Alert -->
                @if (data.type === 'error') {
                <svg class="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm-1-9V6a1 1 0 112 0v3a1 1 0 11-2 0zm0 4a1 1 0 102 0 1 1 0 00-2 0z"
                        clip-rule="evenodd" />
                </svg>
                }
                <!-- Info Circle-i -->
                @if (dialogType() === 'info') {
                <svg class="w-8 h-8" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                    fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M10 11h2v5m-2 0h4m-2.592-8.5h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                </svg>
                }
                <!-- Warning Triangle -->
                @if (data.type === 'warning') {
                <svg class="w-8 h-8" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                    fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 9v4m0 4h.01M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
                </svg>
                }
            </header>

            <!-- CONTENT SECTION - Header + Message/Table -->
            <div class="flex flex-col items-baseline pt-2">
                <!-- Dialog Title -->
                <h2 class="section-title">
                    {{ data.header }}
                </h2>

                <!-- STRING CONTENT (simple message) -->
                @if (isString()) {
                <p class="text-gray-600 text-left whitespace-pre-line">
                    {{ textContent() }}
                </p>
                }
                <!-- ARRAY CONTENT (mapping table) -->
                @else if (isArray()) {
                <table class="w-full border-collapse">
                    <tr class="bg-gray-100 border-b border-gray-200">
                        <th class="p-2 text-left">Input Column</th>
                        <th class="p-2 text-left">Output Column</th>
                        <th class="p-2 text-left">Type of Mapping</th>
                        <th class="p-2 text-left">Reason</th>
                    </tr>
                    @for (d of tableContent(); track d) {
                    <tr class="border-b border-gray-100">
                        <td class="p-1" [ngClass]="{'bg-red-300': !d.input_column}">{{ d.input_column }}</td>
                        <td class="p-1" [ngClass]="{'bg-red-300': !d.output_column}">{{ d.output_column }}</td>
                        <td class="p-1" [ngClass]="{'bg-red-300': !d.type_of_mapping}">{{ d.type_of_mapping }}</td>
                        <td class="p-1" [ngClass]="{'bg-red-300': !d.reason}">{{ d.reason }}</td>
                    </tr>
                    }
                </table>
                }
            </div>
        </div>

        <!-- BUTTON SECTION - DYNAMIC BASED ON MODE -->
        <div class="flex w-full justify-end p-4 gap-2 flex-shrink-0 border-t">
            <!-- MODE 1: Regular dialogs (success/error/info) - SINGLE Dismiss/OK button -->
            @if (!data.showProceed) {
            <button (click)="closeDialog()" [ngClass]="{
                        'bg-green-600 hover:bg-green-700': data.type === 'success',
                        'bg-red-500 hover:bg-red-600': data.type === 'error',
                        'bg-blue-600 hover:bg-blue-700': dialogType() === 'info',
                        'bg-amber-500 hover:bg-amber-600': data.type === 'warning'
                    }"
                class="px-5 py-2 rounded-full text-sm font-semibold text-white transition-all duration-200 hover:shadow-md">
                {{ data.confirm || 'Dismiss' }}
            </button>
            }

            <!-- MODE 2: Continue confirmation - TWO buttons [Cancel] [Proceed] -->
            @if (data.showProceed) {
            <!-- Cancel — only rendered when a label is explicitly provided -->
            @if (data.cancelLabel) {
            <button (click)="onCancel()"
                class="px-5 py-2 rounded-full text-sm font-semibold text-gray-600 bg-gray-100 hover:bg-gray-200 border border-gray-300 transition-all duration-200 hover:shadow-md">
                {{ data.cancelLabel }}
            </button>
            }

            @if (data.secondaryActionLabel) {
            <button (click)="onSecondaryAction()"
                class="px-5 py-2 rounded-full text-sm font-semibold text-white bg-amber-500 hover:bg-amber-600 transition-all duration-200 hover:shadow-md">
                {{ data.secondaryActionLabel }}
            </button>
            }

            <!-- Proceed - primary colour -->
            <button (click)="onProceed()"
                class="px-5 py-2 rounded-full text-sm font-semibold text-white transition-all duration-200 hover:shadow-md"
                [style.background-color]="dialogType() === 'warning' ? '#d97706' : 'var(--primary-color)'">
                {{ data.proceedLabel || 'Proceed' }}
            </button>
            }
        </div>
    </div>
</div>
